/**
 * --- Initializes the image preview modal with dynamic title and sizing. ---
 */
export function initializePhotoPreview(container) {
    const scope = container || document;
    const modalContainer = document.getElementById(
        'imagePreviewModalContainer',
    );
    const imageContent = document.getElementById('imagePreviewContent');
    const closeButton = modalContainer?.querySelector('.window-close');
    const modalTitle = modalContainer?.querySelector('.window-title');

    if (!modalContainer || !imageContent || !closeButton || !modalTitle) return;

    const originalTitle = modalTitle.innerText;
    const modal = modalContainer.querySelector('.window');
    const triggers = scope.querySelectorAll('.js-photo-preview-trigger');

    const closeModal = () => {
        modalContainer.classList.remove('window-modal-open');
        modal.classList.remove('window-open');
        imageContent.src = '';
        modal.classList.remove(
            'image-modal--portrait',
            'image-modal--landscape',
        );
        modalTitle.innerText = originalTitle;
    };

    closeButton.addEventListener('click', closeModal);
    modalContainer.addEventListener('click', (event) => {
        if (event.target === modalContainer) {
            closeModal();
        }
    });

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            const imageUrl = this.dataset.url;
            const fileName = this.alt;

            if (!imageUrl) return;

            if (fileName) {
                modalTitle.innerText = `${originalTitle} - ${fileName}`;
            }

            imageContent.onload = () => {
                const { naturalWidth, naturalHeight } = imageContent;

                modal.classList.remove(
                    'image-modal--portrait',
                    'image-modal--landscape',
                );

                if (naturalHeight > naturalWidth) {
                    modal.classList.add('image-modal--portrait');
                } else {
                    modal.classList.add('image-modal--landscape');
                }

                modalContainer.classList.add('window-modal-open');
                modal.classList.add('window-open');

                imageContent.onload = null;
            };

            imageContent.src = imageUrl;
        });
    });
}
